import { useEffect, useRef } from "react";
import Headings from "../../../../components/Headings/Headings";
import SearchableMultiSelectDropdown from "../../../../components/DynamicDropdowns/SearchableMultiSelectDropdown";
import { mergeSelectedIntoOptions } from "../../../../components/Hooks/classDetailMultiDropdownHook";

interface CollabProps {
  inputValue: boolean;
  setInputValue: React.Dispatch<React.SetStateAction<boolean>>;
  collabOrganisation: any[];
  setCollabOrganisation: React.Dispatch<React.SetStateAction<any[]>>;
  organisationList: any[];
  orgListLoading: boolean;
  fetchOrgOptions: (search: string) => void;
}
const Collaboration: React.FC<CollabProps> = ({
  inputValue,
  setInputValue,
  collabOrganisation,
  setCollabOrganisation,
  organisationList,
  orgListLoading,
  fetchOrgOptions,
}: CollabProps) => {
  const checkRef: any = useRef(null);

  useEffect(() => {
    document
      .querySelector("aui-checkbox")
      ?.addEventListener("auiCheckboxChange", getValue);
    return () => {
      document
        .querySelector("aui-checkbox")
        ?.removeEventListener("auiCheckboxChange", getValue);
    };
  }, []);
  const getValue = async (event: any) => {
    const refValue = await checkRef.current?.getCurrentValue();
    setInputValue(refValue);
  };
  const mergedOptions = mergeSelectedIntoOptions(
    organisationList,
    collabOrganisation
  );

  return (
    <div>
      <div className="d-flex flex-row align-items-center my-3">
        <aui-checkbox
          checkboxid="example"
          label=""
          value={inputValue}
          ref={checkRef}
        />
        <Headings
          size="h2"
          defaultClass="h7 blue"
          className={`mt-2 bordered pb-0 mb-0`}
        >
          In Collaboration Class
        </Headings>
      </div>
      {inputValue && (
        <div className="col-12 col-md-4 p-0 pb-3 mb-lg-0">
          <SearchableMultiSelectDropdown
            dropId="CollaboratingOrganisation(s)"
            dropdownLabel="Collaborating Organisation(s)"
            placeHolder="Select Organisation(s)"
            data={mergedOptions}
            selectedOptions={collabOrganisation}
            isLoading={orgListLoading}
            onSearch={fetchOrgOptions}
            onChange={(selected) => {
              setCollabOrganisation(selected);
            }}
          />
        </div>
      )}
    </div>
  );
};

export default Collaboration;
